import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faPlus, faEdit, faMinus, faStopwatch20 } from '@fortawesome/free-solid-svg-icons';
import { Counter } from '../../shared/models/counter.model';
import { CounterService } from './counter.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
    selector: 'app-counter',
    templateUrl: './counter.component.html',
    styleUrls: ['./counter.component.css'],
    standalone: false
})
export class CounterComponent implements OnInit {

  @ViewChild('setMaxModal') setMaxModal: ElementRef;
  @ViewChild('setActualNumberModal') setActualNumberModal: ElementRef;

  public orgId: number;
  public icons: { [name: string]: any } = {
    'faPlus': faPlus,
    'faMinus': faMinus,
    'faEdit': faEdit,
    'faStopwatch20': faStopwatch20
  };
  public counterInformations: Counter = new Counter();

  public organization: Organization;

  constructor(private _activatedRoute: ActivatedRoute, private _counterService: CounterService,
    private _modalService: NgbModal, private _sharedService: SharedService, private _router: Router) { }

  ngOnInit(): void {
    const routeParams = this._activatedRoute.snapshot.params;
    if (!routeParams.orgId) {
      this._router.navigate(['/']);
    }
    this.orgId = routeParams.orgId;

    this._sharedService.getOrganization(routeParams.orgId).subscribe(requestResult => {
      this.organization = requestResult;
      this._sharedService.organizationNameSubject.next({ 'de': this.organization.name_de, 'it': this.organization.name_it });
    }, requestError => {
      console.log(requestError);
    });

    this._counterService.getCounterInformations(routeParams.orgId).subscribe(() => {
      this.counterInformations = this._counterService.counter;
    }, error => {
      console.log(error);
    });
    this._counterService.onCounterChange.subscribe(() => {
      this.counterInformations.blocked = 0;
      this.counterInformations = this._counterService.counter;
    });
  }

  /**
   * onCounterActionButtonClick
   */
  public onCounterActionButtonClick(action: string): void {
    if (action === 'edit') {
      this._modalService.open(this.setActualNumberModal, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this._counterService.setCurrentPeopleValue(result, this.orgId.toString());
      });
    } else {
      this._counterService.setCounterValue((action === 'plus' ? 1 : -1), this.orgId.toString());
    }
  }

  public onOrganizationCloseStatusChange(event: any): void {
    this._counterService.setClosed((event.target.checked ? 0 : 1), this.orgId.toString());
  }

  public onOrganizationBlockStatusChange(event: any): void {
    this._counterService.setBlocked((event.target.checked ? 1 : 0), this.orgId.toString());
  }

  onMaxButtonClick() {
    this._modalService.open(this.setMaxModal, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this._counterService.setMaxPeopleValue(result, this.orgId.toString());
    });
  }

}
